import React from "react";
import { uploadPhoto } from "../api/photoApi";

export default function PhotoSlot({ value, onChange, onDelete, propertyId, onUploaded, onUploadState, style }) {
  const [busy, setBusy] = React.useState(false);
  const [askReplace, setAskReplace] = React.useState(false);
  const fileRef = React.useRef(null);

  const pick = () => fileRef.current?.click();

  const handlePick = async (e) => {
    const files = e.target && e.target.files;
    const file = (files && files[0]) || null;
    e.target.value = ""; // 같은 파일 다시 선택 가능
    if (!file) { setAskReplace(false); return; }
    try {
      onUploadState?.(true);                    // 업로드 시작 알림
      setBusy(true);
      // propertyId를 항상 숫자로 포함
      const fd = new FormData();
      fd.append('file', file);
      const pid = Number(propertyId) || 0;
      fd.append('propertyId', String(pid));
      console.log('[PhotoSlot] POST /api/photo-storage propertyId =', pid);
      const res = await fetch(`/api/photo-storage?propertyId=${pid}`, {
        method: 'POST',
        body: fd,
      });
      if (!res.ok) throw new Error('upload failed');
      const result = await res.json();
      let url = "";
      if (typeof result === "string") {
        url = result;
      } else if (result) {
        const server = result.server_thumb_url || result.serverThumbUrl || "";
        const fid    = result.thumb_drive_id  || result.thumbFileId  || "";
        const base = server || (fid ? `/api/photo-storage/${fid}/preview` : "") ||
                     result.thumbViewUrl || result.thumbUrl ||
                     result.webContentLink || result.webViewLink || result.url || "";
        url = base ? `${base}${base.includes('?') ? '&' : '?'}t=${Date.now()}` : "";
        // 부모로 새 메타 전달
        onUploaded?.({ estate_no: pid, thumb_url: server, thumb_file_id: fid });
      }
      onChange?.(url);                           // 슬롯 갱신
    } catch (err) {
      alert(err?.message || "업로드 실패");
    } finally {
      setBusy(false); // “생성중” 종료 보장
      onUploadState?.(false);                   // 업로드 종료 알림(실패 포함)
      setAskReplace(false);
    }
  };

  const handleClick = () => {
    if (!value) pick();
    else setAskReplace(true);
  };

  return (
    <div
      onClick={handleClick}
      style={{
        position: "relative",
        width: "100%",
        height: "100%",
        ...(style || {}),
        // 비율 유지 + 꽉 채움은 img 쪽에서 처리
        background: value ? "#000" : "#f5f5f5",
        border: value ? "1px solid transparent" : "1px dashed #c9c9c9",
        cursor: "pointer",
        borderRadius: 8,
        overflow: "hidden"
      }}
    >
      {/* 이미지 */}
      {value ? (
        <img
          src={value}
          alt=""
          style={{ width: "100%", height: "100%", objectFit: "contain" /* PHOTO_RATIO_V1: 잘림없이 비율유지 */ }}
          draggable={false}
        />
      ) : (
        <div
          style={{
            position: "absolute", inset: 0, display: "flex",
            alignItems: "center", justifyContent: "center",
            color: "#666", fontSize: 14
          }}
        >
          사진을 등록하려면 클릭
        </div>
      )}

      {/* 업로딩 오버레이 */}
      {busy && (
        <div
          style={{
            position: "absolute", inset: 0, background: "rgba(0,0,0,.45)",
            display: "flex", alignItems: "center", justifyContent: "center",
            color: "#fff", fontWeight: 600
          }}
        >
          생성중…
        </div>
      )}

      {/* 교체 확인 오버레이 */}
      {askReplace && !busy && (
        <div
          onClick={(e) => e.stopPropagation()}
          style={{
            position: "absolute", inset: 0, background: "rgba(0,0,0,.45)",
            display: "flex", flexDirection: "column", gap: 12,
            alignItems: "center", justifyContent: "center", color: "#fff"
          }}
        >
          <div style={{ fontWeight: 700 }}>사진을 교체 하시겠습니까?</div>
          <div style={{ display: "flex", gap: 8 }}>
            <button
              onClick={pick}
              style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #fff", background: "transparent", color: "#fff" }}
            >
              교체
            </button>
            <button
              onClick={() => setAskReplace(false)}
              style={{ padding: "6px 12px", borderRadius: 6, border: "1px solid #ddd", background: "#fff", color: "#333" }}
            >
              취소
            </button>
          </div>
        </div>
      )}

      {/* 숨김 파일 입력 */}
      <input
        ref={fileRef}
        type="file"
        accept="image/*"
        onChange={handlePick}
        style={{ display: "none" }}
      />
    </div>
  );
}
